import React from "react"

export default function SectionDescription({ children }) {
  return (
    <div className="columns-1 sm:columns-2 gap-x-12 font-mono text-xs sm:text-sm xl:text-base text-primary mt-0 sm:mt-24">
      {children}
    </div>
  )
}
